import {
  PAYMENT_INTEGRITY_DETAILS_SUCCESS,
  PAYMENT_INTEGRITY_DETAILS_FAILURE,
  PAYMENT_INTEGRITY_DETAILS_LOADING
} from '../../../actions/actionTypes';

interface PaymentIntegrityDetailsState {
  detailsData: any;
  isLoading: boolean;
  error: boolean;
}

const initialState: PaymentIntegrityDetailsState = {
  detailsData: [],
  isLoading: true,
  error: false,
};

const PaymentIntegrityDetailsReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentIntegrityDetailsState => {
  switch (action.type) {
    case PAYMENT_INTEGRITY_DETAILS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case PAYMENT_INTEGRITY_DETAILS_SUCCESS:
      return {
        ...state,
        detailsData: action.payload,
        error: false
      };

    case PAYMENT_INTEGRITY_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        detailsData: null
      };

    default:
      return state;
  }
};

export default PaymentIntegrityDetailsReducer;